import classNames from 'classnames';
import { memo } from 'react';
import { IContainerLayoutProps } from './ContainerLayout.types';
import styles from './styles.module.scss';

export const ContainerLayout = memo<IContainerLayoutProps>(
  ({ children, outerContainerClassName, innerContainerClassName }) => (
    <section className={classNames(styles.container, outerContainerClassName)}>
      <div className={classNames(styles.innerContainer, innerContainerClassName)}>{children}</div>
    </section>
  ),
);

ContainerLayout.displayName = 'ContainerLayout';

export default ContainerLayout;
